import { render } from "./ModalCrew.vue?vue&type=template&id=0fb38e25"
import script from "./ModalCrew.vue?vue&type=script&lang=js"
export * from "./ModalCrew.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__